import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { CustomLink } from 'components/CustomLink';
import routes from 'router/routes';
import { useTranslation } from 'react-i18next';
import { ToastContainer } from 'react-toastify';
import s from './CrmLayout.module.scss';

function CrmLayout(): JSX.Element {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const navLinks = [
    { to: routes.crmDashboard.path, label: t('crm:tab_dashboard') },
    { to: routes.crmPipeline.path, label: t('crm:tab_pipeline') },
    { to: routes.crm.path, label: t('crm:tab_prospects') },
    { to: routes.crmCompanies.path, label: t('crm:companies') },
  ];

  const isActive = (linkPath: string): boolean => {
    if (linkPath === routes.crmDashboard.path) {
      return pathname === linkPath || pathname === linkPath + '/';
    }
    return pathname.startsWith(linkPath);
  };

  return (
    <div className={s.layout}>
      <header className={s.header}>
        <div className={s.headerInner}>
          <div className={s.headerLeft}>
            <span className={s.logo}>CRM</span>
            <nav className={s.nav}>
              {navLinks.map((link) => (
                <CustomLink
                  key={link.to}
                  to={link.to}
                  className={isActive(link.to) ? s.navLinkActive : s.navLink}
                >
                  {link.label}
                </CustomLink>
              ))}
            </nav>
          </div>
          <div className={s.headerRight}>
            <button
              type="button"
              className={s.backBtn}
              onClick={() => navigate(routes.admEventList.path)}
            >
              &larr; {t('crm:back_to_app')}
            </button>
          </div>
        </div>
      </header>
      <main className={s.main}>
        <Outlet />
      </main>
      <ToastContainer stacked />
    </div>
  );
}

export default CrmLayout;
